import { Link } from "react-router-dom";

const productLinks = [
  { label: "商務會議", to: "/business-meeting" },
  { label: "離線翻譯", to: "/offline-translation" },
  { label: "商務差旅", to: "/business-travel" },
  { label: "使用方式", to: "/how-it-works" },
  { label: "方案價格", to: "/pricing" },
];

const resourceLinks = [
  { label: "知識內容", to: "/blog" },
  { label: "支援中心", to: "/support" },
  { label: "常見問題", to: "/support" },
  { label: "關於 keepvox", to: "/about" },
];

const legalLinks = [
  { label: "隱私權政策", to: "/privacy-policy" },
  { label: "服務條款", to: "/terms" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-800 bg-background-900">
      <div className="mx-auto w-full max-w-7xl px-6 py-16 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="font-heading text-xl font-bold tracking-tight text-foreground-50">
              keepvox<span className="text-primary-400">.</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300">
              離線商務口譯 × 雙語會議記錄 × 商務差旅助手
            </p>
            <p className="mt-6 text-sm text-foreground-400">
              Published by
              <br />
              天地人網整合行銷顧問有限公司
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50">產品</h4>
            <ul className="mt-4 space-y-3">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50">資源</h4>
            <ul className="mt-4 space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50">Legal</h4>
            <ul className="mt-4 space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-background-800 pt-8 text-sm text-foreground-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 天地人網整合行銷顧問有限公司</p>
          <p>All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}